<template>
        <div>
                 <el-dialog
                        title="车牌变更"
                        width="65%"
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        车牌变更
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll">
                        <avue-form
                                ref="form"
                                v-model="form"
                                :option="option"
                                @submit="saveCarCharge"
                                >
                        </avue-form>
                </div>
                <template slot="footer">
                        <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                        <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
                </template>
                </el-dialog>
        </div>
</template>
<script>
import {
    carNoChange,
    checkCarIsExist
  } from '@/api/v4ward/park/storedValueCar/storedValueCar';

export default {
        props:{
                projectList:{
                        type:Array,
                        default(){
                                return []
                        }
                }
        },
        data(){
                return{
                        loading:false,
                        data:[],
                        dialogVisible:false,
                        dialogFull:false,
                        plateNumber:'',
                        page: {
                                pageSize: 10,
                                currentPage: 1,
                                total: 0,
                        },
                        option:{
                                align: 'center',
                                emptyBtn: false,
                                submitText: '保存',
                                submitBtn:false,
                                column: [
                                {
                                        label: '车场名称',
                                        type: 'tree',
                                        prop: 'spaceId',
                                        span: 8,
                                        search: true,
                                        cell: true,
                                        clearable: false,
                                        disabled: true,
                                        props: {
                                                label: 'title',
                                                value: 'key',
                                        },
                                        rules: [
                                                {
                                                message: '请选择车场名称',
                                                required: true,
                                                },
                                        ],
                                        dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',

                                },
                                {
                                        label: '车牌号',
                                        prop: 'plateNumber',
                                        disabled: true,
                                        span: 8,
                                        rules: [
                                                {
                                                required: true,
                                                message: '请选择车牌号',
                                                trigger: 'change',
                                                },
                                        ],
                                },



                                {
                                        label: '余额',
                                        prop: 'carBalance',
                                        precision: 2,
                                        width: 70,
                                        disabled: true,
                                        hide: true,
                                        maxlength: 15,
                                        showWordLimit: true,
                                        mock: {
                                                type: 'number',
                                                max: 1,
                                                min: 2,
                                                precision: 2,
                                        },
                                        rules: [
                                                { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
                                        ],
                                        minRows: 0.01,
                                        span: 8,
                                },
                                {
                                        label: '新车牌号',
                                        prop: 'newPlateNumber',
                                        width: 100,
                                        span:8,
                                        rules: [
                                                {
                                                        required: true,
                                                        message: '请输入车牌',
                                                        trigger: 'blur',
                                                },
                                                {
                                                        required: true,
                                                        pattern: this.$validation.carPlate,
                                                        message: '车牌格式不对',
                                                        trigger: 'change',
                                                },
                                        ],
                                },
                                {
                                        label: '说明',
                                        prop: 'changeRemark',
                                        hide: true,
                                        span: 16,
                                        type: 'input',
                                        minRows: 2,
                                        maxlength: 200,
                                        showWordLimit: true,
                                        overHidden: true,

                                },
                                ],
                        }

                }
        },
        methods:{
                openDialog(row){
                        this.form = {
                                id:row.id,
                                spaceId:row.spaceId,
                                plateNumber:row.plateNumber,
                                carBalance:row.carBalance,
                                changeRemark:'',
                                newPlateNumber:'',
                        }
                        this.dialogVisible = true;
                },
                formSubmit1(){
                        checkCarIsExist({spaceId:this.form.spaceId,newPlateNumber:this.form.newPlateNumber,plateNumber:this.form.plateNumber}).then(res=>{
                                if(res.data){
                                        this.$confirm(`车辆【${this.form.newPlateNumber}】已为储值车，是否将车辆【${this.form.plateNumber}】的余额转移至车辆【${this.form.newPlateNumber}】下。`, {
                                                confirmButtonText: '确定',
                                                cancelButtonText: '取消',
                                                type: 'warning',
                                        })
                                        .then(() => {
                                                this.$refs.form.submit();
                                        })
                                } else{
                                        this.$refs.form.submit();
                                }

                        })

                },
                saveCarCharge(form,done){
                        this.loading = true;
                  let self = this;
                        carNoChange(form).then(res=>{
                                if(res.success){
                                        this.$message({
                                                type: "success",
                                                message: "操作成功!"
                                        });
                                        this.$emit('onLoad')
                                         this.dialogVisible = false;
                                }
                                done()
                                this.loading = false;
                        }).catch(REs=>{
                                done();
                                this.loading = false;
                          self.dialogVisible = false;
                        })
                },
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {

                                self.dialogVisible = false;

                        })
                        .catch(()=> {

                        });
                },



        }
}
</script>
